














import { Component, Vue } from 'vue-property-decorator'
import { SweetModal } from 'sweet-modal-vue'

@Component({
  components: {
    SweetModal
  }
})
export default class IntroModal extends Vue {
  mounted() {
    ;(this.$refs.intro_modal as any).open() // eslint-disable-line no-alert
  }

  handleButtonClick() {
    ;(this.$refs.intro_modal as any).close() // eslint-disable-line no-alert
  }
}
